/* eslint-disable */
import i18n from "../i18n";
import { toast } from "react-toastify";
import { ofType, ActionsObservable } from "redux-observable";
import { ajax } from "rxjs/ajax";
import { switchMap, catchError, map, mergeMap } from "rxjs/operators";
import { amarantFieldsTypes } from "../actions/amarantFields";
import { AMARANT2_API_URL, API_URL } from "../config/settings";
import { Headers } from "../utils/Headers";
import { from } from "rxjs";
import { of } from "rxjs";

export const getVehicles = (action$) => {
  return action$.pipe(
    ofType(amarantFieldsTypes.LIST_VEHICLES),
    switchMap(({ payload }) => {
      return ajax({
        url: `${AMARANT2_API_URL}/customerSupport/listVehicles`,
        method: "POST",
        headers: Headers.basicAuth(),
        body: JSON.stringify(payload),
      }).pipe(
        switchMap(({ response }) => {
          return ActionsObservable.create((obs) => {
            obs.next({
              type: amarantFieldsTypes.LIST_VEHICLES_SUCCESS,
              payload: response.payload,
            });
            obs.complete();
          });
        }),
        catchError((err) => {
          return ActionsObservable.create((obs) => {
            if (err.status === 401) {
              window.location.href = "/login";
            } else {
            }
          });
        })
      );
    })
  );
};

export const getPolicies = (action$) => {
  return action$.pipe(
    ofType(amarantFieldsTypes.LIST_POLICIES),
    switchMap(({ payload }) => {
      return ajax({
        url: `${AMARANT2_API_URL}/customerSupport/listPolicies`,
        method: "POST",
        headers: Headers.basicAuth(),
        body: JSON.stringify(payload),
      }).pipe(
        switchMap(({ response }) => {
          return ActionsObservable.create((obs) => {
            obs.next({
              type: amarantFieldsTypes.LIST_POLICIES_SUCCESS,
              payload: response.payload,
            });
            obs.complete();
          });
        }),
        catchError((err) => {
          return ActionsObservable.create((obs) => {
            if (err.status === 401) {
              window.location.href = "/login";
            } else {
            }
          });
        })
      );
    })
  );
};

export const getVignettes = (action$) => {
  return action$.pipe(
    ofType(amarantFieldsTypes.LIST_VIGNETTES),
    switchMap(({ payload }) => {
      return ajax({
        url: `${AMARANT2_API_URL}/customerSupport/listVignettes`,
        method: "POST",
        headers: Headers.basicAuth(),
        body: JSON.stringify(payload),
      }).pipe(
        switchMap(({ response }) => {
          return ActionsObservable.create((obs) => {
            obs.next({
              type: amarantFieldsTypes.LIST_VIGNETTES_SUCCESS,
              payload: response.payload,
            });
            obs.complete();
          });
        }),
        catchError((err) => {
          return ActionsObservable.create((obs) => {
            if (err.status === 401) {
              window.location.href = "/login";
            } else {
            }
          });
        })
      );
    })
  );
};

export const getFines = (action$) => {
  return action$.pipe(
    ofType(amarantFieldsTypes.LIST_FINES),
    switchMap(({ payload }) => {
      return ajax({
        url: `${AMARANT2_API_URL}/customerSupport/listFines`,
        method: "POST",
        headers: Headers.basicAuth(),
        body: JSON.stringify(payload),
      }).pipe(
        switchMap(({ response }) => {
          return ActionsObservable.create((obs) => {
            obs.next({
              type: amarantFieldsTypes.LIST_FINES_SUCCESS,
              payload: response.payload,
            });
            obs.complete();
          });
        }),
        catchError((err) => {
          return ActionsObservable.create((obs) => {
            if (err.status === 401) {
              window.location.href = "/login";
            } else {
            }
          });
        })
      );
    })
  );
};

export const getErrors = (action$) => {
  return action$.pipe(
    ofType(amarantFieldsTypes.LIST_ERRORS),
    switchMap(({ payload }) => {
      return ajax({
        url: `${AMARANT2_API_URL}/customerSupport/listErrors`,
        method: "POST",
        headers: Headers.basicAuth(),
        body: JSON.stringify(payload),
      }).pipe(
        switchMap(({ response }) => {
          return ActionsObservable.create((obs) => {
            obs.next({
              type: amarantFieldsTypes.LIST_ERRORS_SUCCESS,
              payload: response.payload,
            });
            if (payload?.onSuccess) payload?.onSuccess(response);
            obs.complete();
          });
        }),
        catchError((err) => {
          return ActionsObservable.create((obs) => {
            if (err.status === 401) {
              window.location.href = "/login";
            } else {
            }
          });
        })
      );
    })
  );
};

export const getDocuments = (action$) => {
  return action$.pipe(
    ofType(amarantFieldsTypes.LIST_DOCUMENTS),
    switchMap(({ payload }) => {
      return ajax({
        url: `${AMARANT2_API_URL}/customerSupport/listDrivingLicenses`,
        method: "POST",
        headers: Headers.basicAuth(),
        body: JSON.stringify(payload),
      }).pipe(
        switchMap(({ response }) => {
          return ActionsObservable.create((obs) => {
            obs.next({
              type: amarantFieldsTypes.LIST_DOCUMENTS_SUCCESS,
              payload: response.payload,
            });
            if (payload?.onSuccess) payload?.onSuccess(response?.payload);
            obs.complete();
          });
        }),
        catchError((err) => {
          return ActionsObservable.create((obs) => {
            if (err.status === 401) {
              window.location.href = "/login";
            } else {
            }
          });
        })
      );
    })
  );
};

export const getUserInfo = (action$) => {
  return action$.pipe(
    ofType(amarantFieldsTypes.USER_INFO),
    switchMap(({ payload }) => {
      return ajax({
        url: `${AMARANT2_API_URL}/customerSupport/userInfo`,
        method: "POST",
        headers: Headers.basicAuth(),
        body: JSON.stringify(payload),
      }).pipe(
        switchMap(({ response }) => {
          return ActionsObservable.create((obs) => {
            payload.onSuccess(response.payload);
            obs.next({
              type: amarantFieldsTypes.USER_INFO_SUCCESS,
              payload: response.payload,
            });
            obs.complete();
          });
        }),
        catchError((err) => {
          return ActionsObservable.create((obs) => {
            console.log(err);
            toast.error(err?.response?.message);
            if (err.status === 401) {
              window.location.href = "/login";
            } else {
            }
          });
        })
      );
    })
  );
};

export const editUserInfo = (action$) => {
  return action$.pipe(
    ofType(amarantFieldsTypes.EDIT_USER_INFO),
    switchMap(({ payload }) => {
      return ajax({
        url: `${AMARANT2_API_URL}/customerSupport/userInfo`,
        method: "PUT",
        headers: Headers.basicAuth(),
        body: JSON.stringify(payload),
      }).pipe(
        switchMap(({ response }) => {
          return ActionsObservable.create((obs) => {
            payload.onSuccess(response.payload);
            obs.next({
              type: amarantFieldsTypes.EDIT_USER_SUCCESS,
              payload: response.payload,
            });
            obs.complete();
          });
        }),
        catchError((err) => {
          return ActionsObservable.create((obs) => {
            if (err.status === 401) {
              window.location.href = "/login";
            } else {
            }
          });
        })
      );
    })
  );
};

export const checkAmarantUserEpic = (action$) => {
  return action$.pipe(
    ofType(amarantFieldsTypes.CHECK_AMARANT_USER),
    switchMap(({ payload }) => {
      return ajax({
        url: `${AMARANT2_API_URL}/customerSupport/getCustomerSupportId`,
        method: "POST",
        headers: Headers.basicAuth(),
        body: JSON.stringify({
          phoneNumber: payload.phone,
        }),
      }).pipe(
        switchMap(({ response }) => {
          return ActionsObservable.create((obs) => {
            if (response?.payload?.found) {
              payload.onSuccess(response);
            } else {
              payload.onError();
            }
            obs.complete();
          });
        }),
        catchError((err) => {
          return ActionsObservable.create((obs) => {
            toast.error(i18n.t("app:customerLookupFailed"));
          });
        })
      );
    })
  );
};

export const sendTemplateEpic = (action$) => {
  return action$.pipe(
    ofType(amarantFieldsTypes.SEND_TEMPLATE),
    switchMap(({ payload }) => {
      return ajax({
        url: `${AMARANT2_API_URL}/customerSupport/sendEmail`,
        method: "POST",
        headers: Headers.basicAuth(),
        body: JSON.stringify(payload),
      }).pipe(
        switchMap(({ response }) => {
          return ActionsObservable.create((obs) => {
            payload.onSuccess(response);
            obs.complete();
          });
        }),
        catchError((err) => {
          return ActionsObservable.create((obs) => {
            console.log(err);
          });
        })
      );
    })
  );
};

export const updatePolicyEpic = (action$) => {
  return action$.pipe(
    ofType(amarantFieldsTypes.UPDATE_POLICY),
    switchMap(({ payload }) => {
      // Check if policy has an _id
      if (!payload.policy._id) {
        console.error("No policy ID found", payload.policy);
        if (payload?.onError) payload?.onError();
        return of({ type: amarantFieldsTypes.UPDATE_POLICY_ERROR });
      }

      console.log(
        "Sending policy update request:",
        JSON.stringify(payload.policy)
      );

      return ajax({
        url: `${AMARANT2_API_URL}/customerSupport/policy`,
        method: "PUT",
        headers: Headers.basicAuth(),
        body: JSON.stringify(payload.policy),
      }).pipe(
        switchMap(({ response }) => {
          console.log("Update policy response:", response);
          return ActionsObservable.create((obs) => {
            if (payload?.onSuccess) payload?.onSuccess({ success: true });
            obs.next({
              type: amarantFieldsTypes.UPDATE_POLICY_SUCCESS,
              payload: response.payload || payload.policy,
            });
            obs.complete();
          });
        }),
        catchError((err) => {
          console.error("Error updating policy:", err);
          return ActionsObservable.create((obs) => {
            // Try to extract error message from response
            let errorMessage = "Error updating policy";
            if (err.response?.error?.message) {
              errorMessage = err.response.error.message;
            } else if (err.message) {
              errorMessage = err.message;
            }

            if (payload?.onError) {
              payload?.onError(errorMessage);
            }
            toast.error(errorMessage);
            obs.complete();
          });
        })
      );
    })
  );
};

export const deletePolicyEpic = (action$) => {
  return action$.pipe(
    ofType(amarantFieldsTypes.DELETE_POLICY),
    switchMap(({ payload }) => {
      // Check if policy id is provided
      if (!payload.policyId) {
        console.error("No policy ID found for deletion", payload);
        if (payload?.onError) payload?.onError();
        return of({ type: amarantFieldsTypes.DELETE_POLICY_ERROR });
      }

      console.log(`Sending policy delete request for ID: ${payload.policyId}`);
      console.log("Full payload:", payload);

      return ajax({
        url: `${AMARANT2_API_URL}/customerSupport/policy`,
        method: "DELETE",
        headers: Headers.basicAuth(),
        body: JSON.stringify({ _id: payload.policyId }),
      }).pipe(
        switchMap(({ response }) => {
          console.log("Delete policy response:", response);
          return ActionsObservable.create((obs) => {
            if (payload?.onSuccess) payload?.onSuccess({ success: true });
            obs.next({
              type: amarantFieldsTypes.DELETE_POLICY_SUCCESS,
              payload: { policyId: payload.policyId },
            });
            obs.complete();
          });
        }),
        catchError((err) => {
          console.error("Error deleting policy:", err);
          return ActionsObservable.create((obs) => {
            // Try to extract error message from response
            let errorMessage = "Error deleting policy";
            if (err.response?.error?.message) {
              errorMessage = err.response.error.message;
            } else if (err.message) {
              errorMessage = err.message;
            }

            console.error("Error details:", err.response || err);

            if (payload?.onError) {
              payload?.onError(errorMessage);
            }
            toast.error(errorMessage);
            obs.next({ type: amarantFieldsTypes.DELETE_POLICY_ERROR });
            obs.complete();
          });
        })
      );
    })
  );
};

export const updateInstallmentEpic = (action$) => {
  return action$.pipe(
    ofType(amarantFieldsTypes.UPDATE_INSTALLMENT),
    switchMap(({ payload }) => {
      console.log("Updating installment with payload:", payload);

      if (!payload.installment || !payload.installment._id) {
        console.error("Missing installment ID for update");
        if (payload?.onError) {
          payload.onError();
        }
        return ActionsObservable.create((obs) => {
          obs.complete();
        });
      }

      // Simplified request body according to documentation
      const body = {
        _id: payload.installment._id,
        dueDate: payload.installment.dueDate,
        amount: payload.installment.amount,
        paid: payload.installment.paid,
      };

      console.log(
        "Sending request data to PUT /customerSupport/installment:",
        JSON.stringify(body)
      );

      return ajax({
        url: `${AMARANT2_API_URL}/customerSupport/installment`,
        method: "PUT",
        headers: Headers.basicAuth(),
        body: JSON.stringify(body),
      }).pipe(
        switchMap(({ response }) => {
          console.log("Update installment response:", response);
          return ActionsObservable.create((obs) => {
            if (payload?.onSuccess) payload?.onSuccess(response?.payload);
            obs.next({
              type: amarantFieldsTypes.UPDATE_INSTALLMENT_SUCCESS,
              payload: response.payload,
            });
            obs.complete();
          });
        }),
        catchError((err) => {
          console.error("Error updating installment:", err);
          return ActionsObservable.create((obs) => {
            if (payload?.onError) payload?.onError(err);
            if (err.status === 401) {
              window.location.href = "/login";
            } else {
              toast.error(i18n.t("app:installmentUpdateFailed"));
            }
            obs.complete();
          });
        })
      );
    })
  );
};

export const searchVehicleEpic = (action$) => {
  return action$.pipe(
    ofType(amarantFieldsTypes.SEARCH_VEHICLE),
    switchMap(({ payload }) => {
      return ajax({
        url: `${AMARANT2_API_URL}/customerSupport/searchVehicle`,
        method: "POST",
        headers: Headers.basicAuth(),
        body: JSON.stringify({
          licensePlate: payload.registrationNumber,
          customerSupportId: payload.customerSupportId,
        }),
      }).pipe(
        switchMap(({ response }) => {
          console.log("API response for searchVehicle:", response);
          return ActionsObservable.create((obs) => {
            // Send response to component first
            if (payload?.onSuccess) payload?.onSuccess(response);

            let vehicleData;

            // When we have success: true directly in the response
            if (response.success === true && response._id) {
              vehicleData = response;
              console.log("Direct vehicle data found:", vehicleData);
            }
            // When we have vehicle data in payload
            else if (response.payload) {
              vehicleData = response.payload;
              console.log("Vehicle data in payload:", vehicleData);
            }
            // If no vehicle data found
            else {
              vehicleData = null;
              console.log("No vehicle data found");
            }

            obs.next({
              type: amarantFieldsTypes.SEARCH_VEHICLE_SUCCESS,
              payload: vehicleData,
            });
            obs.complete();
          });
        }),
        catchError((err) => {
          console.error("Search vehicle error:", err);
          return ActionsObservable.create((obs) => {
            if (payload?.onError) payload?.onError();
            toast.error(i18n.t("app:vehicleSearchFailed"));
            obs.next({
              type: amarantFieldsTypes.SEARCH_VEHICLE_ERROR,
              payload: err,
            });
            obs.complete();
          });
        })
      );
    })
  );
};

export const listPaymentIntentsEpic = (action$) => {
  return action$.pipe(
    ofType(amarantFieldsTypes.LIST_PAYMENT_INTENTS),
    switchMap(({ payload }) => {
      return ajax({
        url: `${AMARANT2_API_URL}/customerSupport/listPaymentIntents`,
        method: "POST",
        headers: Headers.basicAuth(),
        body: JSON.stringify({
          customerSupportId: payload.customerSupportId,
        }),
      }).pipe(
        switchMap(({ response }) => {
          return ActionsObservable.create((obs) => {
            if (payload?.onSuccess) payload?.onSuccess(response);

            // Check different API response formats
            const paymentData = Array.isArray(response)
              ? response
              : response.payload || [];

            console.log("Payment intent response:", response);
            console.log("Processed payment data:", paymentData);

            obs.next({
              type: amarantFieldsTypes.LIST_PAYMENT_INTENTS_SUCCESS,
              payload: paymentData,
            });
            obs.complete();
          });
        }),
        catchError((err) => {
          return ActionsObservable.create((obs) => {
            if (err.status === 401) {
              window.location.href = "/login";
            } else {
              if (payload?.onError) payload?.onError(err);
              toast.error(i18n.t("app:paymentsLoadFailed"));
            }
            obs.complete();
          });
        })
      );
    })
  );
};
